import React, { Component } from 'react';
import { Container, Table, Button, Spinner } from 'react-bootstrap';
import axios from 'axios';
import { withRouter } from 'react-router-dom';

import { AdminNav, Loading } from '../../helpers';
import {convertRiceTypeENToTH} from '../../helpers/function'

import './styleTable.css';


class ValidPageTable extends Component {
}

export default withRouter(ValidPageTable);

